import type { ModuleManifest } from '../types.js'

/**
 * ХУР — төрийн мэдээлэл солилцооны системээс ИРГЭНИЙ ЛАВЛАГАА авах модуль.
 *
 * ! ЭНЭ МОДУЛЬ ӨГӨГДЛИЙГ ЭЗЭМШДЭГГҮЙ. Иргэний мэдээлэл нь улсын бүртгэлд
 * ! амьдардаг; бид зөвхөн лавлаж, ХН-ийн маягтыг бөглөх, бичсэнтэй тулгахад
 * ! хэрэглэнэ. Баазад үлдэх цорын ганц зүйл нь ЛАВЛАГААНЫ ЖУРНАЛ — хэн, хэний
 * ! мэдээллийг, хэзээ, ямар үндэслэлээр харав.
 *
 * ! ЛАВЛАЛТ БҮР ӨӨРИЙН ЭРХТЭЙ, `hr.employees:edit`-т нуугдаагүй. ХН-ийн туслах
 * ! ажилтан анкет хянаж болох ч улсын бүртгэлээс иргэний мэдээлэл татах нь
 * ! ӨӨР шийдвэр — хувь хүний мэдээлэл боловсруулах эрх нь албан тушаалаас
 * ! биш, тусгайлан оноогддог байх ёстой.
 *
 * Дэлгэрэнгүй — гэрээ, драйверууд, хууль зүйн үндэслэл: `docs/43-xyp-hur.md`.
 */
export const xypModule = {
  key: 'xyp',
  name: 'ХУР лавлагаа',
  description: 'Регистрийн дугаараар иргэний албан ёсны мэдээллийг лавлаж, ХН-ийн бүртгэлтэй тулгана.',
  version: '1.0.0',
  icon: 'IdCardIcon',

  /*
   * ! ТӨРЛӨӨР ХУВААСАН, ҮЙЛДЛЭЭР БИШ. `lookup` нь бүх лавлалтад нэг үйлдэл;
   * ! ялгаа нь ЮУ лавлахад байна. Иргэний үнэмлэх татах, НДШ-ийн ажилласан
   * ! түүх татах хоёр нь өөр гүн — нэг эрхэнд нэгтгэвэл нэгийг өгөхөд нөгөө нь
   * ! дагаж нээгдэнэ.
   */
  permissions: [
    { resource: 'xyp.citizen', action: 'lookup', description: 'Иргэний үнэмлэх, хаягийн лавлагаа' },
    { resource: 'xyp.insurance', action: 'lookup', description: 'Нийгмийн даатгалын лавлагаа' },
    { resource: 'xyp.family', action: 'lookup', description: 'Гэр бүл, гэрлэлтийн лавлагаа' },

    /*
     * Журналыг унших нь лавлахаас ТУСДАА: лавлагаа авдаг хүн өөрийн болон
     * бусдын хандалтын түүхийг цэгцлэх эрхтэй байх шаардлагагүй. Энэ нь
     * хяналтын эрх — дотоод аудит, мэдээллийн эзэнд тайлагнахад.
     */
    { resource: 'xyp.journal', action: 'list', description: 'Лавлагааны журнал харах' },
  ],

  navigation: [
    {
      label: 'ХУР',
      items: [
        {
          label: 'Лавлагааны журнал',
          href: '/xyp/journal',
          icon: 'FileSearchIcon',
          iconClassName: 'text-teal-600 dark:text-teal-400',
          permission: 'xyp.journal:list',
        },
      ],
    },
  ],

  /*
   * Зөвхөн журнал нь Refine-ийн resource. Лавлалт нь ЖАГСААЛТ БИШ, ҮЙЛДЭЛ —
   * `useCustomMutation`-ээр дуудагдана (регистрийн дугаар нь query string-д
   * гарах ёсгүй тул POST). Тиймээс resource болгох зүйл байхгүй.
   */
  resources: [
    {
      name: 'xyp.journal',
      label: 'Лавлагааны журнал',
      list: '/xyp/journal',
    },
  ],
} as const satisfies ModuleManifest
